import { createRoot } from "react-dom/client";
import ThemeProvider from "./theme/index.tsx";
import App from "./App.tsx";
import "@/styles/index.scss";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);

// Mock mode is opt-in. Vite inlines the flag at build time, so a bundle built without it drops the
// dynamic import entirely; the mock preview target the browser journeys run against keeps it.
async function startApiMocks() {
  if (import.meta.env.VITE_ENABLE_API_MOCKS !== "true") return;
  const { startMockWorker } = await import("./mocks/browser");
  await startMockWorker();
}

startApiMocks()
  .then(() =>
    createRoot(document.getElementById("root")!).render(
      <ThemeProvider>
        <App />
      </ThemeProvider>
    )
  )
  .catch((error: unknown) => {
    console.error("Failed to start the API mocks", error);
    document.getElementById("root")!.textContent = "API mocks could not start. Check the console and reload.";
  });
